import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Pictures from "../DetailsComponents/Pictures";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BottomPictures from "../DetailsComponents/BottomPictures";
import Description from "../DetailsComponents/Description";
import StrongPoint from "../DetailsComponents/StrongPoint";
import img1 from "../../../assets/Image/Details2/Photo1.jpg";
import img2 from "../../../assets/Image/Details2/Photo2.jpg";
import img3 from "../../../assets/Image/Details2/Photo3.jpg";
import img4 from "../../../assets/Image/Details2/Photo4.jpg";
import img5 from "../../../assets/Image/Details2/Photo5.jpg";
import img6 from "../../../assets/Image/Details2/Photo6.jpg";
import img7 from "../../../assets/Image/Details2/Photo7.jpg";
import img8 from "../../../assets/Image/Details2/Photo8.jpg";
import img9 from "../../../assets/Image/Details2/Photo9.jpg";
import img10 from "../../../assets/Image/Details2/Photo10.jpg";
import {
    faArrowLeft,
    faLocation,
    faPaintRoller,
} from "@fortawesome/free-solid-svg-icons";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

const images = [img1, img2, img3, img4, img5];
const images2 = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10];

const DetailsId2 = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);
    const navigate = useNavigate();

    const handleImageClick = (index) => {
        setPhotoIndex(index);
        setIsOpen(true);
    };

    return (
        <div>
            <div className="px-48 xl:px-28 lg:px-24 md:px-14 sm:px-6">
                <button
                    className="w-10 h-10 mt-1 bg-customGray text-black rounded-full p-2 tansition duration-300 ease-in-out transform hover:text-customPink hover:bg-white hover:scale-125"
                    onClick={() => navigate("/acheter-louer")}
                >
                    <FontAwesomeIcon
                        className="m-auto text-base"
                        icon={faArrowLeft}
                    />
                </button>
                <Pictures
                    title="Maison entièrement à rénover"
                    images={images}
                    onImageClick={handleImageClick}
                />
                <BottomPictures
                    place="Rue de Tron, 86360 Montamisé"
                    state="Sous-offre"
                />
                <h5 className="text-2xl mt-20 mb-10">Points forts du bien</h5>
                <div className="mb-20 flex justify-around items-center reveal-left lg:flex-wrap lg:gap-8 md:flex-wrap md:gap-8 sm:flex-wrap sm:gap-8">
                    <StrongPoint
                        icon={faLocation}
                        text="Proche de Poitiers et du Futuroscope"
                    />
                    <StrongPoint
                        icon={faPaintRoller}
                        text="Entièrement à rénover"
                    />
                </div>
                <Description
                    text="Maison à vendre d'environ 90m² habitable sur un terrain de 265m² située à Tronc (commune de Montamisé). Calme et bien disposée, elle se compose en rez de chaussée d'une spacieuse pièce de vie avec conduit de cheminée (possibilité de mettre un insert), cuisine séparée avec rangements ouvrant sur un cour d'environ 35m², toilettes séparées. A l'étage deux chambres spacieuses. Possibilité création salle d'eau à l'étage.
                    Deux dépendances (dont une pouvant faire office de buanderie) et un grand garage de 40m² complète ce bien. Rénovation à prévoir."
                />
            </div>
            {isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
                    <button
                        className="absolute top-4 right-4 text-white text-2xl"
                        onClick={() => setIsOpen(false)}
                    >
                        &times;
                    </button>
                    <div className="w-8/12 md:w-3/4 lg:w-3-4 sm:w-full">
                        <Carousel
                            selectedItem={photoIndex}
                            showThumbs={true}
                            showStatus={false}
                            swipeable={true}
                            autoPlay={true}
                            interval={4000}
                            infiniteLoop
                            useKeyboardArrows
                            onChange={(index) => setPhotoIndex(index)}
                        >
                            {images2.map((img, index) => (
                                <div key={index}>
                                    <img
                                        src={img}
                                        alt={`Show ${index + 1}`}
                                        className="object-contain w-full"
                                    />
                                </div>
                            ))}
                        </Carousel>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DetailsId2;
